import { map } from 'ramda';
import mapContext from './mapContext';

const mapContextGroups = (groups) => map((groupContexts) => map((context) => mapContext(context, false), groupContexts), groups);

export default mapContextGroups;
